module.exports = __webpack_public_path__ + "img/RORBPJR40037.9ef7a4a3.png";